/**
 * Users and Invites API
 *
 * API client functions for user management and invite system.
 * Types are derived from the generated OpenAPI contract.
 */

import { apiClient } from './client';
import type {
  User,
  UserListResponse,
  UserUpdate,
  Invite,
  InviteListResponse,
} from './generated/contract-types';
import type { InviteListParams, InviteCreate } from './types';

export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<User>('/auth/me');
  return response.data;
};

export const getUsers = async (
  page: number = 1,
  perPage: number = 50,
  role?: string,
  search?: string
): Promise<UserListResponse> => {
  const params: Record<string, string | number> = { page, perPage };
  if (role) params.role = role;
  if (search) params.search = search;

  const response = await apiClient.get<UserListResponse>('/auth/users', { params });
  return response.data;
};

export const getUser = async (id: number): Promise<User> => {
  const response = await apiClient.get<User>(`/auth/users/${id}`);
  return response.data;
};

export const updateUser = async (id: number, data: UserUpdate): Promise<User> => {
  const response = await apiClient.patch<User>(`/auth/users/${id}`, data);
  return response.data;
};

export const createInvite = async (data: InviteCreate): Promise<Invite> => {
  const response = await apiClient.post<Invite>('/auth/invites', data);
  return response.data;
};

export const getInvites = async (params?: InviteListParams): Promise<InviteListResponse> => {
  const response = await apiClient.get<InviteListResponse>('/auth/invites', {
    params,
  });
  return response.data;
};
